import { getRole, getRoles } from './'

export const fetchRoles = async () => {
  const req = await getRoles()
  return {
    type: 'GET_ROLES_SUCCESS',
    data: req.roles
  }
}

export const fetchRole = async (slug) => {
  const req = await getRole(slug)
  return {
    type: 'GET_ROLE_SUCCESS',
    data: req.role
  }
}
